import EventHandler from '@pixelunion/events';
import AsyncView from '@pixelunion/shopify-asyncview';
import ProductDetails from './ProductDetails';
import ProductGallery from './ProductGallery';
import PaymentTerms from '../helpers/PaymentTerms';

import Tabs from './Tabs';
import Accordion from './Accordion';

export default class ProductQuickshop {
  constructor(productCard) {
    this.productCard = productCard;

    this.productCardLink = productCard.querySelector('.product-thumbnail__link');
    this.quickshopButton = productCard.querySelector('[data-quickshop-button]');

    this.events = new EventHandler();

    this.events.register(this.quickshopButton, 'click', e => {
      e.preventDefault();

      // Build request url
      const requestUrl = this.quickshopButton.dataset.quickshopUrl;

      window.modal.open({
        trigger: this.productCardLink,
        classname: 'modal--quickshop',
        onClose: () => {
          if (this.productGallery) {
            const { players, flickity } = this.productGallery;
            if (players) {
              players.forEach(player => {
                if (player.playing) {
                  player.pause();
                }
              });
            }

            if (flickity) {
              flickity.options.autoPlay = 0;
            }
          }
        },
      });

      // Run AsyncView to populate quickshop HTML
      AsyncView.load(
        requestUrl,
        { view: '_quickshop' },
      ).then(({ data, html }) => {
        const container = document.createElement('div');
        container.innerHTML = html.content;

        this.paymentTerms = new PaymentTerms(container);

        this.productGallery = new ProductGallery({
          el: container,
          product: data.product,
          settings: data,
        });

        this.productDetails = new ProductDetails({
          el: container,
          product: data.product,
          variantInventory: data.variantInventory,
          settings: data,
          onVariantChange: variant => {
            this.productGallery.updateGalleryImageByVariant(variant);
            this.paymentTerms.update(variant.id);
          },
        });

        if (Shopify.theme_settings.cart_action_type === 'ajax' && this.productDetails.formArea) {
          const atcButton = this.productDetails.formArea.querySelector('[data-product-atc]');

          this.events.register(atcButton, 'click', event => {
            const ev = new Event('quickshop-add', { bubbles: true });
            atcButton.dispatchEvent(ev);
            event.preventDefault();
          });
        }

        window.modal.updateContent(container);

        // Initialize Shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        new Tabs();
        new Accordion();
      });
    });
  }

  unload() {
    if (this.productGallery) {
      this.productGallery.unload();
    }

    if (this.productDetails) {
      this.productDetails.unload();
    }
  }
}
